import { render, staticRenderFns } from "./CustomerDetailGroups.vue?vue&type=template&id=09a00822&scoped=true&"
import script from "./CustomerDetailGroups.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailGroups.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailGroups.vue?vue&type=style&index=0&id=09a00822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a00822",
  null
  
)

export default component.exports